import instance, { ApiResponse } from "api";
import { endpoints } from "config";
import {
  ActionsObservable,
  StateObservable,
  combineEpics,
  ofType,
} from "redux-observable";
import { from, of } from "rxjs";
import { catchError, filter, map, mergeMap, switchMap } from "rxjs/operators";
import { signOut } from "./auth";
import { Store } from "./rootReducer";
import {
  BackendBusinessVerificationStage,
  BusinessVerificationStage,
  BusinessVerificationStatusResponse,
  getStageFromBackend,
} from "pages/Onboarding/Verification/verificationModels";
import { Toast, ToastMessageReason } from "components/helpers/toast";
import { DocumentRejection } from "pages/Onboarding/Verification/Verification";

type AdditionalData = {
  iframeUrl?: string;
  bManualAvailable?: boolean;
} | null;

interface State {
  isVerified: boolean;
  currentStage: BusinessVerificationStage | null;
  checking: boolean;
  // venueGroupsID: number | null;
  additionalData?: AdditionalData;
  rejectedDocuments?: DocumentRejection | null;
}
// | DocumentRejection;

const initialState: State = {
  isVerified: false,
  currentStage: null,
  checking: false,
  additionalData: null,
  rejectedDocuments: null,
  // venueGroupsID: null,
};

enum ActionType {
  FETCH_VERIFICATION_STATUS = "FETCH_VERIFICATION_STATUS",
  SET_VERIFICATION_STATUS = "SET_VERIFICATION_STATUS",
  DELETE_VERIFICATION_STATUS = "DELETE_VERIFICATION_STATUS",
  UPDATE_VERIFICATION_STATUS = "UPDATE_VERIFICATION_STATUS",
  SET_VENUE_GROUP_ID = "UPDATE_VENUE_GROUP_ID",
}

type Action =
  | { type: ActionType.FETCH_VERIFICATION_STATUS }
  | {
      type: ActionType.SET_VERIFICATION_STATUS;
      payload: State;
    }
  | { type: ActionType.UPDATE_VERIFICATION_STATUS; payload: Partial<State> }
  | { type: ActionType.DELETE_VERIFICATION_STATUS };
// | { type: ActionType.SET_VENUE_GROUP_ID; payload: Partial<State> };

const reducer = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case ActionType.SET_VERIFICATION_STATUS:
      return action.payload as State;
    case ActionType.UPDATE_VERIFICATION_STATUS:
      return { ...state, ...action.payload };
    case ActionType.DELETE_VERIFICATION_STATUS:
      return initialState;
    // case ActionType.SET_VENUE_GROUP_ID:
    //   return { ...state, ...action.payload };
    case ActionType.FETCH_VERIFICATION_STATUS:
      return {
        ...state,
        checking: true,
      };
    default:
      return state;
  }
};

const fetchStatus = () => {
  return from(
    instance.get<ApiResponse<BusinessVerificationStatusResponse>>(
      endpoints.verification.verificationStatus
      // { params: { venueGroupdsId: id } }
    )
  );
};

const fetchVerificationStatusEpic = (
  action$: ActionsObservable<{
    type: ActionType.FETCH_VERIFICATION_STATUS;
    // payload?: number;
  }>,
  state$: StateObservable<Store>
) => {
  return action$.pipe(
    ofType(ActionType.FETCH_VERIFICATION_STATUS),
    switchMap(action$ => {
      return fetchStatus().pipe(
        filter(response => response.data.status === "1"),
        map(response => response.data.details),
        map(details => {
          return setVerificationStatus({
            checking: false,
            isVerified:
              details.venueGroupVerificationStep ===
              BackendBusinessVerificationStage.Verified,
            currentStage: getStageFromBackend(
              details.venueGroupVerificationStep
            ),
            additionalData: details.additionalData,
            rejectedDocuments: details.rejectedDocuments,
          });
        }),
        // map(() => {
        //   if (action$.payload) {
        //     return setVenueGroupsID({
        //       venueGroupsID: action$.payload,
        //     });
        //   }
        // }),
        catchError(() => {
          Toast.openToastMessage(
            "There was an error checking your verification status. Please try again later.",
            ToastMessageReason.ERROR
          );
          return of(signOut());
        })
      );
    })
  );
};
export default reducer;
export const verificationEpic = combineEpics(fetchVerificationStatusEpic);
//action creators
const setVerificationStatus = (payload: State): Action => {
  return { type: ActionType.SET_VERIFICATION_STATUS, payload: payload };
};
export const deleteVerificationStatus = (): Action => ({
  type: ActionType.DELETE_VERIFICATION_STATUS,
});

export const fetchVerificationStatus = () => ({
  type: ActionType.FETCH_VERIFICATION_STATUS,
});

export const setVerificationStage = (
  payload: Omit<State, "isVerified" | "checking">
): Action => {
  return {
    type: ActionType.UPDATE_VERIFICATION_STATUS,
    payload: { ...payload },
  };
};

// export const setVenueGroupsID = (
//   payload: Pick<State, "venueGroupsID">
// ): Action => {
//   return { type: ActionType.SET_VENUE_GROUP_ID, payload: payload };
// };

export const updateAdditionalData = (
  additionalData: AdditionalData
): Action => {
  return {
    type: ActionType.UPDATE_VERIFICATION_STATUS,
    payload: { additionalData },
  };
};

// Selectors
export const selectVerificationLoading = (store: Store) =>
  store.verification.checking;
export const selectVerificationStatus = (store: Store) => ({
  bVerified: store.verification.isVerified,
  checking: store.verification.checking,
});
export const selectVerificationDetails = (store: Store) => ({
  stage: store.verification.currentStage,
  additionalData: store.verification.additionalData,
  rejectedDocuments: store.verification.rejectedDocuments,
});

// export const selectVenueGroupsID = (store: Store) =>
//   store.verification.venueGroupsID;
